import type {Recommendations} from '~/types/domain/Recommendations';

export type RecommendationItem = {
    id: string;
    authorFirstName: string;
    authorImgUrl: string;
    authorLastName: string;
    textContent: string;
    lastUpdateDate: Date;
    authorCompanyName?: string;
    authorProfileUrl?: string;
};

export enum RecommendationSize {
    SMALL = 'small',
    MEDIUM = 'medium',
}

export function toRecommendations(recommendations: Recommendations): RecommendationItem[] {
    if (recommendations && recommendations.recommendations) {
        return recommendations.recommendations.map((recommendation) => ({
            id: recommendation.id,
            accepted: recommendation.accepted,
            authorCompanyName: recommendation.authorCompanyName,
            authorFirstName: recommendation.authorFirstName,
            authorImgUrl: recommendation.authorImgUrl,
            authorLastName: recommendation.authorLastName,
            authorProfileUrl: recommendation.authorProfileUrl,
            lastUpdateDate: recommendation.lastUpdateDate,
            textContent: recommendation.textContent,
        }));
    }

    return [];
}
